import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_CRYPTO_URL || "http://localhost:8888",
  headers: {
    "x-api-provider": "crypto-xpinvestimentos",
  },
});

export default api;
